import { useI18N } from '@shared-core/hooks/use-i18n'
import { Column } from '@shared-ui/components/ui/grid'
import { Loader } from '@shared-ui/components/ui/loader'
import locales from '@shared-ui/screens/cards/pin-setup/index.i18n.json'
import { useAppTheme } from '@shared-ui/theme'
import { useEffect, useRef, useState } from 'react'
import { isPinProviderSuccessPayload, isPinProviderSuccessTitle } from './constants'
import { useCreateStyles } from './styles'

export type CardPinProviderProps = { url: string; onSuccess: () => void; onError: () => void }

export function CardPinProvider({ url, onSuccess, onError }: CardPinProviderProps) {
  const styles = useCreateStyles()
  const theme = useAppTheme()
  const { t } = useI18N(locales)
  const iframeRef = useRef<HTMLIFrameElement>(null)
  const [isLoading, setIsLoading] = useState(true)
  const successRef = useRef(onSuccess)
  successRef.current = onSuccess
  useEffect(() => {
    const handleMessage = (event: MessageEvent<unknown>) => {
      if (event.source !== iframeRef.current?.contentWindow || !isPinProviderSuccessPayload(event.data)) return
      successRef.current()
    }
    const timer = window.setInterval(() => {
      try {
        if (isPinProviderSuccessTitle(iframeRef.current?.contentDocument?.title)) successRef.current()
      } catch {
        // Заголовок iframe другого домена недоступен; результат приходит через postMessage.
      }
    }, 300)
    window.addEventListener('message', handleMessage)
    return () => {
      window.removeEventListener('message', handleMessage)
      window.clearInterval(timer)
    }
  }, [url])
  return (
    <Column style={styles.provider}>
      <iframe
        ref={iframeRef}
        title={t('title')}
        src={url}
        style={styles.webview}
        allow="clipboard-write *; clipboard-read *"
        sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
        onLoad={() => setIsLoading(false)}
        onError={onError}
      />
      {isLoading && (
        <Column style={styles.loader}>
          <Loader color={theme.COLOR_TEXT_PRIMARY} />
        </Column>
      )}
    </Column>
  )
}
